import {
  getGroupNavigationLoadStatus,
  getNextUnseenGroup,
  getRankedCommunityIdsThrows,
  getViewerCommunitiesWithUnreadGroupsFirst,
  getViewerCommunityIds,
  isViewerCommunitiesCountGreaterThanEqualTo,
} from '@ms/yammer-data/dist/domains/viewerCommunityIdSets/selectors';
import { Group } from '@ms/yammer-data/dist/state/types';

import { useSelector } from '../useSelector';

type UseRankedCommunityIdsThrows = () => ReturnType<typeof getRankedCommunityIdsThrows>;
export const useRankedCommunityIdsThrows: UseRankedCommunityIdsThrows = () => useSelector(getRankedCommunityIdsThrows);

type UseGroupNavigationLoadStatus = () => ReturnType<typeof getGroupNavigationLoadStatus>;
export const useGroupNavigationLoadStatus: UseGroupNavigationLoadStatus = () =>
  useSelector(getGroupNavigationLoadStatus);

type UseNextUnseenGroup = (groupId: Group['id']) => ReturnType<typeof getNextUnseenGroup>;
export const useNextUnseenGroup: UseNextUnseenGroup = (groupId) =>
  useSelector((state) => getNextUnseenGroup(state, groupId));

type UseViewerCommunitiesWithUnreadGroupsFirst = () => ReturnType<typeof getViewerCommunitiesWithUnreadGroupsFirst>;
export const useViewerCommunitiesWithUnreadGroupsFirst: UseViewerCommunitiesWithUnreadGroupsFirst = () =>
  useSelector((state) => getViewerCommunitiesWithUnreadGroupsFirst(state));

type UseViewerCommunityIds = () => ReturnType<typeof getViewerCommunityIds>;
export const useViewerCommunityIds: UseViewerCommunityIds = () => useSelector(getViewerCommunityIds);

type UseIsViewerCommunitiesCountGreaterThanEqualTo = (
  communitiesCount: number
) => ReturnType<typeof isViewerCommunitiesCountGreaterThanEqualTo>;
export const useIsViewerCommunitiesCountGreaterThanEqualTo: UseIsViewerCommunitiesCountGreaterThanEqualTo = (
  communitiesCount
) => useSelector((state) => isViewerCommunitiesCountGreaterThanEqualTo(state, communitiesCount));
